import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { OtherFinancialInfo as OtherFinancialInfoModel } from '../../../../../../generated/model/models';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: OtherFinancialInfoModel[];
  ccy?: BackportingEnums.CcyEnum;
  consolidation?: boolean;
}

const TABLE_FIELDS = ['employeeAverage', 'accountingStandard'];

const OtherFinancialInfo: React.FC<Props> = ({ data, ccy, consolidation = undefined }) => (
  <MatrixDataTable
    title={'otherFinancialInfo'}
    translationsScope={'companies:companyFinancials'}
    data={data}
    tableFields={TABLE_FIELDS}
    showCurrency={false}
    ccy={ccy}
    consolidation={consolidation}
  />
);

export default OtherFinancialInfo;
